var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.587,
    height: 28.287,
    viewBox: "0 0 25.587 28.287",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "promotion",
    transform: "translate(-7.146 -2.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35460",
    "data-name": "Group 35460",
    transform: "translate(7.146 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63868",
    "data-name": "Path 63868",
    d: "M16.444,54.5,15.4,61.512v.03h2.924l.9-6-1.91-.6A3.948,3.948,0,0,1,16.444,54.5Z",
    transform: "translate(-12.937 -38.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63869",
    "data-name": "Path 63869",
    d: "M9.49,26.352l.656-2.3,1.283-.627-.448,4.6a1.467,1.467,0,0,0,.985,1.522l4,1.253.06,4h2.894l-.09-5.073a1.405,1.405,0,0,0-1.014-1.343l-2.536-.806.716-3.163,1.223,1.552a1.182,1.182,0,0,0,1.253.418l2.745-.716a1.2,1.2,0,1,0-.6-2.327l-1.969.507-1.522-1.939c-.06-.06-.09-.119-.149-.179a3.147,3.147,0,0,0-1.4-.716l-2.268-.477a3.1,3.1,0,0,0-2,.239L8.624,22.055A1.2,1.2,0,0,0,8,22.8l-.806,2.835a1.206,1.206,0,0,0,.835,1.492,1.269,1.269,0,0,0,.328.06A1.146,1.146,0,0,0,9.49,26.352Z",
    transform: "translate(-7.146 -15.103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63870",
    "data-name": "Path 63870",
    d: "M34.911,53.5H29.749a.6.6,0,0,0-.6.6v2.238H23.722a.6.6,0,0,0-.6.6v2.238H17.694a.6.6,0,0,0-.6.6V62H11.7a.6.6,0,0,0-.6.6v3.372a.6.6,0,0,0,.6.6H34.911a.6.6,0,0,0,.6-.6V54.037A.59.59,0,0,0,34.911,53.5Z",
    transform: "translate(-9.92 -38.283)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_260",
    "data-name": "Ellipse 260",
    cx: 2.536,
    cy: 2.536,
    r: 2.536,
    transform: "translate(5.715)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotion);
export default __webpack_public_path__ + "static/media/promotion.4f0b8e683b57fc091e322bd69bcd02c5.svg";
export { ForwardRef as ReactComponent };